// Shared by the public navbar and the logged-in app navbar so both bars are the same height.
// Set as a fixed `height` on the Toolbar: MUI's default Toolbar min-heights (56/48/64 by
// breakpoint and orientation) are all at or below this, so it wins at every screen size.
export const NAVBAR_HEIGHT = 64;

// Shared AppBar surface for every navbar: frosted white with a hairline border.
export const navbarSurfaceSx = {
  background: "rgba(255,255,255,0.9)",
  backdropFilter: "blur(10px)",
  color: "#111",
  borderBottom: "1px solid #e5e7eb",
};
